import {
    AdSlotRenderEndedAction,
    AdSlotUnregisterAction,
    AD_SLOT_RENDER_ENDED,
    AD_SLOT_UNREGISTER,
} from 'mk2/containers/AdSlot/AdSlot.actions';
import React from 'react';
import { all, takeLatest } from 'redux-saga/effects';
import styles from './AdSlotBranding.mscss';

function* brandingRendered({ slotId, event }: AdSlotRenderEndedAction) {
    const slot = document.getElementById(slotId);
    const body = document.body;

    if (!event.isEmpty && event.size && Array.isArray(event.size)) {
        // set page to layout according to the size of creative
        // size '1x1' is returned from prebid line item. In that case we know,
        // Adform is configured to only return branding (2000x1400) creatives
        const layout = {2000: 'branding', 970: 'billboard', 1: 'branding'}[event.size[0]];

        // Cleanup layouts
        if (layout === 'branding') {
            body.classList.add(styles['body--branding']);
            body.classList.remove(styles['body--billboard']);
        } else if (layout === 'billboard') {
            body.classList.remove(styles['body--branding']);
            body.classList.add(styles['body--billboard']);
        }

        if (slot) {
            if (layout === 'branding') {
                slot.classList.add(styles['AdSlotBranding--branding']);
            } else {
                slot.classList.remove(styles['AdSlotBranding--branding']);
            }
        }
    } else {
        // reset to normal page layout to normal, we do not have branding
        if (slot) {
            slot.classList.remove(styles['AdSlotBranding--branding']);
        }
        body.classList.remove(styles['body--branding']);
        body.classList.remove(styles['body--billboard']);
    }
}

function* brandingUnregistered({ slotId }: AdSlotUnregisterAction) {
    const body = document.body;
    const slot = document.getElementById(slotId);

    if (slot) {
        slot.classList.remove(styles['AdSlotBranding--branding']);
    }
    body.classList.remove(styles['body--branding']);
    body.classList.remove(styles['body--billboard']);
}

export default function* root() {
    yield all([
        takeLatest((action) => action.type === AD_SLOT_RENDER_ENDED && action.slotId.startsWith('mk-branding'), brandingRendered),
        takeLatest((action) => action.type === AD_SLOT_UNREGISTER && action.slotId.startsWith('mk-branding'), brandingUnregistered),
    ]);
}
